export enum AUTH_PATHNAME {
    login = '/sign-in/',
    register = '/register/'
}

export enum AuthSteps {
    login = 'login',
    signup = 'signup',
    forgot = 'forgot',
    reset = 'reset'
}

export interface ILoginFormsProps {
    setStep?: (value: AuthSteps) => void;
}
